export default "__VITE_ASSET__B8Ou13PG__"